<script setup>
import { inject } from 'vue';
import Saisie from '@/components/generiques/Saisie.vue';
import SelecteurTypeObjet from '@/components/generiques/SelecteurTypeObjet.vue';

const { idErreur, typesObjet, valeurOblig, desactive, placeholder } = defineProps({
    idErreur: String,
    typesObjet: Array,
    valeurOblig: Boolean,
    desactive: Boolean,
    placeholder: String
});

const valeur = defineModel('valeur', {
    type: Object
});

const erreursSaisie = inject('erreursSaisie');

function modifierValeur(typeObjet) {
    valeur.value = typeObjet;
}

</script>

<template>
    <Saisie :message-erreur="erreursSaisie[idErreur]">
        <SelecteurTypeObjet 
            v-model:typeObjet="valeur" 
            :typesObjet="typesObjet"
            :valeurOblig="valeurOblig"
            :desactive="desactive"
            :placeholder="placeholder"
            @update:typeObjet="modifierValeur" />
    </Saisie>
</template>

<style scoped>

</style>